import { ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';

import * as fromSearchSuggestions from './search-suggestions';
import * as fromSearch from './search';
import * as fromCarousel from './carousel';
import * as fromCategories from './categories';
import * as fromCategory from './category';
import { BuyerState } from './state';

export const reducers: ActionReducerMap<BuyerState> = {
  searchSuggestions: fromSearchSuggestions.searchSuggestionsReducer,
  search: fromSearch.searchReducer,
  carousel: fromCarousel.carouselReducer,
  categories: fromCategories.categoriesReducer,
  category: fromCategory.categoryReducer,
};

export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({
    keys: [{searchSuggestions: ['historyTerms']}],
    rehydrate: true,
    storageKeySerializer: () => 'app-generic/storage'
  })(reducer);
}

export const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer];
